export const translations = {
  he: {

    // Navigation
    rsvp: 'הגעה',
    location: 'מיקום',
    present: 'מתנה',

    // RSVP Page
    rsvpTitle: 'אישור הגעה',
    attending: 'אני מגיע/ה',
    notAttending: 'לא אוכל להגיע',
    addToCalendar: 'הוסף ליומן',

    // Guest count modal
    howManyGuests: 'כמה אורחים תהיו ?',
    confirmAttendance: 'אישור הגעה',

    // Transport modal
    attendanceConfirmed: 'הגעתכם אושרה בהצלחה !',
    transportQuestion: 'האם אתה מעוניין בהסעה?',
    noThanks: 'לא / אחליט בהמשך',
    save: 'שמור',
    saved: 'נשמר',

    // Confirmed RSVP status
    confirmedAttendance: 'אישרת הגעה ל',
    people: 'אנשים',
    canChangeChoice: 'ניתן לשנות את הבחירה בכל עת:',
    changeTransport: 'עדכן פרטי הסעה',

    // Alerts
    rsvpYesAlert:
      'אישור ההגעה התקבל בהצלחה. במידה ויהיה שינוי, עדיין ניתן ללחוץ על הכפתורים. לנוחיותכם, ניתן להעניק מתנות בלחיצה על הכפתור מתנה.',
    rsvpNoAlert:
      'זה בסדר, תודה רבה על העדכון. במידה ויהיה שינוי, עדיין ניתן ללחוץ על הכפתורים. לנוחיותכם, ניתן להעניק מתנות בלחיצה על הכפתור מתנה.',
    transportError: 'שגיאה בשמירת ההעדפה, נסה שוב מאוחר יותר.',

    // Loading states
    loading: 'טוען...',
    loadingGeneral: 'טוען...',

    // Gift/Present Section
    giftTitle: 'מתנה לזוג',
    giftSubtitle: 'נשמח אם תרצו להעניק לנו מתנה כספית. כל תרומה תתקבל בברכה ובאהבה רבה ❤️',
    giftAmount: 'סכום המתנה',
    giftMessage: 'ברכה לזוג',
    optional: 'אופציונלי',
    processingFee: 'עמלת עיבוד (1.5%)',
    total: 'סה"כ לתשלום',
    proceedToPayment: 'המשך לתשלום',
    back: 'חזור',
    paymentSummary: 'סיכום תשלום',
    amount: 'סכום',
    yourMessage: 'הברכה שלך',

    // Location Section
    eventLocation: 'מיקום האירוע',
    googleMaps: 'Google Maps',
    waze: 'Waze',

    // Language toggle
    language: 'English',

    // Admin Edit Settings
    editDetails: 'עריכת פרטים',
    step1UserDetails: 'פרטי משתמש',
    wifeFirstname: 'שם פרטי של הכלה',
    wifeLastname: 'שם משפחה של הכלה',
    husbandFirstname: 'שם פרטי של החתן',
    husbandLastname: 'שם משפחה של החתן',
    step2ContactDetails: 'פרטי קשר',
    email: 'אימייל',
    phoneNumber: 'מספר טלפון',
    step3EventDetails: 'פרטי האירוע',
    eventDate: 'תאריך האירוע',
    eventAddress: 'כתובת האירוע',
    rsvpMessages: 'הודעות RSVP',
    firstRsvpMessage: 'הודעת RSVP ראשונה',
    firstRsvpPlaceholder: 'הודעה שנשלחת לבקשת RSVP ראשונה',
    reminderRsvpMessage: 'הודעת תזכורת RSVP',
    reminderRsvpPlaceholder: 'הודעה שנשלחת לתזכורת RSVP',
    generalReminderText: 'טקסט תזכורת כללי',
    generalReminderPlaceholder: 'הודעת תזכורת כללית שניתן לשלוח לפי הצורך',
    afterWeddingThankYou: 'תודה לאחר החתונה',
    afterWeddingPlaceholder: 'הודעת תודה שנשלחת לאחר החתונה',
    whatsappFreeTextLabel: 'טקסט חופשי (אופציונלי)',
    whatsappFreeTextHelp: 'טקסט שיתווסף להודעת ה-WhatsApp הראשונה. השאירו ריק כדי לדלג.',
    whatsappFreeTextWhitespaceError: 'לא ניתן להזין שני רווחים או מעברי שורה רצופים.',
    whatsappFreeTextPlaceholder: 'לדוגמה: דרס קוד, פרטי חניה, או הודעה אישית',
    whatsappLastFreeTextLabel: 'טקסט חופשי להודעה ביום האירוע (אופציונלי)',
    whatsappLastFreeTextHelp: 'הטקסט יתווסף להודעת ה-WhatsApp ביום האירוע. השאירו ריק כדי לדלג.',
    whatsappLastFreeTextPlaceholder: 'לנוחיותכם, ניתן להעניק מתנות באשראי בקישור : https://bit.com',
    whatsappLastMessagePreview: 'תצוגה מקדימה של ההודעה ביום האירוע:',
    transportSettings: 'הגדרות הסעה',
    organizeTransportForGuests: 'ארגון הסעה לאורחים',
    transportStops: 'תחנות הסעה',
    transportStopsDescription: 'הוסף תחנות איסוף לנוחות האורחים',
    noTransportStopsYet: 'עדיין לא הוספת תחנות הסעה',
    clickAddToStart: 'לחץ על "הוסף תחנת הסעה" כדי להתחיל',
    yes: 'כן',
    no: 'לא',
    enterStopLocation: 'הזן מיקום תחנה',
    remove: 'הסר',
    addTransportStop: 'הוסף תחנת הסעה',
    uploadInvitation: 'העלאת הזמנה',
    uploadInvitationTitle: 'העלאת הזמנת החתונה',
    uploadInvitationDescription: 'בחר קובץ תמונה באיכות גבוהה (JPG, PNG) להזמנה הדיגיטלית שלך',
    replaceInvitationTitle: 'החלפת תמונת ההזמנה',
    currentInvitation: 'הזמנה נוכחית',
    newInvitationPreview: 'תצוגה מקדימה',
    changePassword: 'שינוי סיסמה',
    oldPassword: 'סיסמה ישנה',
    currentPasswordPlaceholder: 'הזן סיסמה נוכחית',
    newPassword: 'סיסמה חדשה',
    newPasswordPlaceholder: 'סיסמה חדשה',
    confirmPassword: 'אשר סיסמה',
    confirmPasswordPlaceholder: 'אשר סיסמה',
    saving: 'שומר...',
    saveChanges: 'שמור שינויים',
    detailsUpdatedSuccessfully: 'הפרטים עודכנו בהצלחה!',
    failedToUpdateDetails: 'כשל בעדכון הפרטים',
    newPasswordValidation: 'הסיסמה החדשה חייבת להכיל לפחות 8 תווים, מספר ותו מיוחד.',
    passwordsDoNotMatch: 'הסיסמאות החדשות אינן תואמות.',

    // Export functionality
    exportExcel: 'ייצא לאקסל',

    // Admin Login
    adminLogin: 'כניסת מנהל',
    createAdminAccount: 'יצירת חשבון מנהל',
    username: 'שם משתמש',
    password: 'סיסמה',
    enterUsername: 'הזן שם משתמש',
    enterPassword: 'הזן סיסמה',
    signIn: 'התחבר',
    signingIn: 'מתחבר...',
    forgotPassword: 'שכחת סיסמה?',
    enterVerificationCode: 'הזן קוד אימות',
    verificationCodeSent: 'שלחנו קוד אימות למספר הטלפון שלך',
    enterSixDigitCode: 'הזן קוד בן 6 סיפרות',
    verifyCode: 'אמת קוד',
    verifying: 'מאמת...',
    registrationSuccessful: 'הרישום הושלם בהצלחה! כעת אמת את מספר הטלפון שלך.',
    registrationFailed: 'הרישום נכשל. אנא בדוק את הפרטים.',
    failedToSendCode: 'נכשל בשליחת הקוד. נסה שוב.',
    invalidCredentials: 'שם משתמש או סיסמה שגויים.',
    serverError: 'שגיאת שרת, נסה שוב',
    alreadyHaveAccount: 'כבר יש לך חשבון?',
    newHere: 'חדש כאן?',
    login: 'התחבר',
    register: 'הירשם',
  },
  en: {
    // Navigation
    rsvp: 'RSVP',
    location: 'Location',
    present: 'Gift',

    // RSVP Page
    rsvpTitle: 'RSVP Confirmation',
    attending: 'I will attend',
    notAttending: 'I cannot attend',
    addToCalendar: 'Add to Calendar',

    // Guest count modal
    howManyGuests: 'How many guests will you be?',
    confirmAttendance: 'Confirm Attendance',

    // Transport modal
    attendanceConfirmed: 'Your attendance has been confirmed successfully!',
    transportQuestion: 'Are you interested in transportation?',
    noThanks: "No / I'll decide later",
    save: 'Save',
    saved: 'Saved',

    // Confirmed RSVP status
    confirmedAttendance: 'You confirmed attendance for',
    people: 'people',
    canChangeChoice: 'You can change your choice at any time:',
    changeTransport: 'Change Transport',

    // Alerts
    rsvpYesAlert:
      'Your attendance confirmation was received successfully. If there are any changes, you can still click the buttons. For your convenience, you can give gifts by clicking the gift button.',
    rsvpNoAlert:
      "That's okay, thank you for the update. If there are any changes, you can still click the buttons. For your convenience, you can give gifts by clicking the gift button.",
    transportError: 'Error saving preference, please try again later.',

    // Loading states
    loading: 'Loading',
    loadingGeneral: 'Loading...',

    // Gift/Present Section
    giftTitle: 'Gift for the Couple',
    giftSubtitle: 'We would be happy if you would like to give us a monetary gift. Any contribution will be received with blessing and love ❤️',
    giftAmount: 'Gift Amount',
    giftMessage: 'Message for the Couple',
    optional: 'Optional',
    processingFee: 'Processing Fee (1.5%)',
    total: 'Total to Pay',
    proceedToPayment: 'Proceed to Payment',
    back: 'Back',
    paymentSummary: 'Payment Summary',
    amount: 'Amount',
    yourMessage: 'Your Message',

    // Location Section
    eventLocation: 'Event Location',
    googleMaps: 'Google Maps',
    waze: 'Waze',

    // Language toggle
    language: 'עברית',

    // Admin Edit Settings
    editDetails: 'Edit Details',
    step1UserDetails: 'User Details',
    wifeFirstname: 'Wife Firstname',
    wifeLastname: 'Wife Lastname',
    husbandFirstname: 'Husband Firstname',
    husbandLastname: 'Husband Lastname',
    step2ContactDetails: 'Contact Details',
    email: 'Email',
    phoneNumber: 'Phone Number',
    step3EventDetails: 'Event Details',
    eventDate: 'Event Date',
    eventAddress: 'Event Address',
    rsvpMessages: 'RSVP Messages',
    firstRsvpMessage: 'First RSVP message',
    firstRsvpPlaceholder: 'Message sent for first RSVP request',
    reminderRsvpMessage: 'Reminder RSVP message',
    reminderRsvpPlaceholder: 'Message sent for RSVP reminder',
    generalReminderText: 'General reminder text',
    generalReminderPlaceholder: 'General reminder message that can be sent as needed',
    afterWeddingThankYou: 'After-Wedding thank-you',
    afterWeddingPlaceholder: 'Thank you message sent after the wedding',
    whatsappFreeTextLabel: 'Free text (optional)',
    whatsappFreeTextHelp: 'Extra paragraph added to the first WhatsApp invitation. Leave empty to skip.',
    whatsappFreeTextWhitespaceError: 'Consecutive spaces or line breaks are not allowed.',
    whatsappFreeTextPlaceholder: 'e.g. dress code, parking notes, or a personal note',
    whatsappLastFreeTextLabel: 'Day-of-event message free text (optional)',
    whatsappLastFreeTextHelp: 'Extra text added to the day-of-event WhatsApp message. Leave empty to skip.',
    whatsappLastFreeTextPlaceholder: 'For your convenience, you can give gifts by credit card at: https://bit.com',
    whatsappLastMessagePreview: 'Day-of-event message preview:',
    transportSettings: 'Transport Settings',
    organizeTransportForGuests: 'Organize Transport for Guests',
    transportStops: 'Transport Stops',
    transportStopsDescription: 'Add pickup stations for guest convenience',
    noTransportStopsYet: 'No transport stops added yet',
    clickAddToStart: 'Click "Add Transport Stop" to get started',
    yes: 'Yes',
    no: 'No',
    enterStopLocation: 'Enter stop location',
    remove: 'Remove',
    addTransportStop: 'Add Transport Stop',
    uploadInvitation: 'Upload Invitation',
    uploadInvitationTitle: 'Upload Your Wedding Invitation',
    uploadInvitationDescription: 'Choose a high-quality image file (JPG, PNG) for your digital invitation',
    replaceInvitationTitle: 'Replace invitation image',
    currentInvitation: 'Current invitation',
    newInvitationPreview: 'New image preview',
    changePassword: 'Change Password',
    oldPassword: 'Old Password',
    currentPasswordPlaceholder: 'Enter current password',
    newPassword: 'New Password',
    newPasswordPlaceholder: 'New Password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm Password',
    saving: 'Saving...',
    saveChanges: 'Save Changes',
    detailsUpdatedSuccessfully: 'Details updated successfully!',
    failedToUpdateDetails: 'Failed to update details',
    newPasswordValidation: 'New password must be at least 8 characters, contain a number and a special character.',
    passwordsDoNotMatch: 'New passwords do not match.',

    // Export functionality
    exportExcel: 'Export to Excel',

    // Admin Login
    adminLogin: 'Admin Login',
    createAdminAccount: 'Create Admin Account',
    username: 'Username',
    password: 'Password',
    enterUsername: 'Enter your username',
    enterPassword: 'Enter your password',
    signIn: 'Sign In',
    signingIn: 'Signing In...',
    forgotPassword: 'Forgot password?',
    enterVerificationCode: 'Enter Verification Code',
    verificationCodeSent: "We've sent a verification code to your phone number",
    enterSixDigitCode: 'Enter 6-digit code',
    verifyCode: 'Verify Code',
    verifying: 'Verifying...',
    registrationSuccessful: 'Registration successful! Now verify your phone number.',
    registrationFailed: 'Registration failed. Please check your details.',
    failedToSendCode: 'Failed to send code. Try again.',
    invalidCredentials: 'Invalid username or password.',
    serverError: 'Server error, try again',
    alreadyHaveAccount: 'Already have an account?',
    newHere: 'New here?',
    login: 'Log in',
    register: 'Register',
  },
}
